export var useSessionStorage = function (key) {
    var getItem = function () {
        var _a;
        try {
            return JSON.parse((_a = sessionStorage.getItem(key)) !== null && _a !== void 0 ? _a : '');
        }
        catch (e) {
            return null;
        }
    };
    var setItem = function (value) {
        try {
            return sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (e) {
            return null;
        }
    };
    var removeItem = function () {
        try {
            return sessionStorage.removeItem(key);
        }
        catch (e) {
            return null;
        }
    };
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem
    };
};
